var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "lbs-viewer-right-side" }, [
    _c("div", {
      staticClass: "lbs-uscope-container",
      attrs: { id: _vm.uScopeDivId }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/viewer/components/UscopeComponent.vue?vue&type=template&id=018c7439&
// module id = 314
// module chunks = 0